<div fxLayout="column" fxLayoutAlign=" center" *ngIf="enviado===0">
    <h6 class="ft17 ft500 centertext">Ayudanos a mejorar compartiendo tu experiencia.</h6>
    <br>

    <h6 class="ft13 default-font-color mg0">¿Cómo calificarías el nivel del instructor?</h6>
    <div>
        <ngb-rating [(rate)]="valoracion.instructor" [max]="5" class="mgb08">
            <ng-template let-fill="fill">
                <span [class.filled]="fill === 100" [class.notfilled]="fill === 0" class="mgr05 ft22">
                    &#9733;
                </span>
            </ng-template>
        </ngb-rating>
    </div>



    <h6 class="ft13 default-font-color mg0">¿Cómo calificarías los conocimientos adquiridos?</h6>
    <div>
        <ngb-rating [(rate)]="valoracion.conocimientos" [max]="5" class="mgb08">
            <ng-template let-fill="fill">
                <span [class.filled]="fill === 100" [class.notfilled]="fill === 0" class="mgr05 ft22">
                    &#9733;
                </span>
            </ng-template>
        </ngb-rating>
    </div>


    <h6 class="ft13 default-font-color mg0">¿Cómo calificarías el material del curso?</h6>
    <div>
        <ngb-rating [(rate)]="valoracion.material" [max]="5" class="mgb08">
            <ng-template let-fill="fill">
                <span [class.filled]="fill === 100" [class.notfilled]="fill === 0" class="mgr05 ft22">
                    &#9733;
                </span>
            </ng-template>
        </ngb-rating>
    </div>

    <h6 class="ft13 default-font-color mg0">¿Cómo calificarías la plataforma de aprendizaje?</h6>
    <div>
        <ngb-rating [(rate)]="valoracion.plataforma" [max]="5" class="mgb20">
            <ng-template let-fill="fill">
                <span [class.filled]="fill === 100" [class.notfilled]="fill === 0" class="mgr05 ft22">
                    &#9733;
                </span>
            </ng-template>
        </ngb-rating>
    </div>

    <p class="ft12 default-font-color">Deja un comentario acerca del curso</p>
    <textarea type="text" [(ngModel)]="valoracion.comentario" class="fw"></textarea>
    <button *ngIf="valoracion.plataforma*valoracion.instructor*valoracion.conocimientos*valoracion.material!=0" type="button" class="darkButton fw mgt05"
        (click)="enviar(); enviado=1">Enviar</button>
    <button *ngIf="valoracion.plataforma*valoracion.instructor*valoracion.conocimientos*valoracion.material==0" type="button"
        class="cursorDefault fw mgt05" >Enviar</button>
</div>

<div *ngIf="enviado===1" class="w250px">
    <div *ssrExclude>
        <mini-spinner></mini-spinner>
    </div>
</div>

<div fxLayout="column" fxLayoutAlign=" center" *ngIf="enviado===2">
    <h6 class="ft17 ft500 centertext">Agradecemos tu valoración</h6>
    <br>
    <p class="centertext">Tu opinión es muy importante para nosotros.</p>
</div>